import { translationMixin } from '@tools/translation';
import { StepperStatusEnum } from './stepperEnum';

export const stepperMixin = {
  mixins: [ translationMixin ],
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    actualStep: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    stepperType: {
      type: String,
      default: '',
    },
    iconInfo: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getStepColor(step) {
      if (step < this.actualStep) {
        return StepperStatusEnum.DONE;
      }
      if (step === this.actualStep) {
        return StepperStatusEnum.IN_PROGRESS;
      }
      return StepperStatusEnum.FUTURE;
    },
    isLastStep(step) {
      return step === this.steps.length - 1;
    },
    getColor(step) {
      return step < this.actualStep ? 'green' : 'grey';
    },
    isDisabledText(step) {
      return !(step <= this.actualStep);
    },
  },
};
